import { Checkbox as DsCheckbox } from 'admination-react'

export function Checkbox({
  label,
  checked,
  onChange,
  disabled = false,
}: {
  label: string
  checked: boolean
  onChange: (v: boolean) => void
  disabled?: boolean
}) {
  return (
    <div className={disabled ? 'field is-disabled' : 'field'}>
      <DsCheckbox
        checked={checked}
        disabled={disabled}
        onChange={(e) => onChange(e.target.checked)}
      >
        {label}
      </DsCheckbox>
    </div>
  )
}
